// @flow
import * as React from 'react';
import { Button, Form, Input, message } from 'antd';
import './modify.scss';
import { useNavigate } from 'react-router-dom';

type Props = {};

export const Modify = (props: Props) => {
  let navigate = useNavigate();

  const onFinish = (values: any) => {
    if (values.password_1 !== values.password_2) {
      message.error('密码不一致,请重新确认密码');
    } else {
    }
  };

  return (
    <div className="modify">
      <div className="content">
        <div className="introduce">请修改您的密码！</div>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input placeholder="请输入用户名" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="oldpassword"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="请输入原始密码" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password_1"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password_2"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="请再次确认密码" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              确认修改
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
